import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000';

const api = axios.create({
  baseURL: API_URL,
  withCredentials: false, // pour les cookies pour auth (A GERER PLUS TARD)
  headers: {
    'Content-Type': 'application/json',
  },
});

// Intercepteurs pour gérer les tokens, erreurs, etc.
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // Pour le débogage, affiche les headers de chaque requête
    console.log('Request Headers:', config.headers);
    console.log('Request URL:', config.url);
    return config;
  },
  (error) => Promise.reject(error)
);


// Intercepteur pour gérer les réponses et les erreurs
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("Erreur API:", error);
    
    // Gérer les erreurs d'authentification (401)
    if (error.response && error.response.status === 401) {
      // Supprimer le token et l'utilisateur du localStorage
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      
      // Si la route n'est pas déjà /login, rediriger vers la page de connexion
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login';
      }
    }
    
    return Promise.reject(error);
  }
);


export default api;